/**
 * Resolve the Colyseus endpoint for direct Vite dev and reverse-proxied smoke tests.
 *
 * Direct dev (`localhost:5173`) keeps using the game server port. Proxied builds
 * use `/colyseus`, which Apache strips before forwarding to `server-game`.
 */
export function resolveColyseusEndpoint(): string {
  const configured = import.meta.env.VITE_COLYSEUS_ENDPOINT?.trim();
  if (configured) return configured;

  const { hostname, host, port, protocol } = window.location;
  const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';

  if (port === '5173' || port === '5174') {
    return `${wsProtocol}//${hostname}:2567`;
  }

  return `${wsProtocol}//${host}/colyseus`;
}
